// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"446":"ecd9ca09","638":"af312557","720":"ecd9ca09","848":"bcf31c45"}[chunkId] + ".chunk.css";
};